import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Footer.css';
import { useLanguage } from '../../context/LanguageContext';
import { FiPhone, FiMapPin, FiClock } from 'react-icons/fi';

const Footer = () => {
  const { lang } = useLanguage();
  const location = useLocation();

  const content = {
    en: {
      home: "Home",
      start: "Getting started",
      courses: "All Courses",
      faq: "Faq",
      about: "About",
      updates: "Stay Updated",
      contact: "Contact Us",
      expTitle: "Our Experience",
      web: "Web Design",
      prog: "Programming",
      cust: "Customer Service",
      teach: "Teaching",
      phoneHeader: "Phone number",
      addressHeader: "Address",
      hoursHeader: "Business Hours",
      monFri: "Mon-Fri",
      sat: "Sat",
      sun: "Sun: Closed",
      rights: "All rights reserved.",
      location: "27F Shinjuku i Land Tower, 6-5-1 Nishishinjuku, Shinjuku-Ku Tokyo, Japan 163-1327"
    },
    jp: {
      home: "ホーム",
      start: "はじめる",
      courses: "コース紹介",
      faq: "よくある質問",
      about: "会社概要",
      updates: "最新情報",
      contact: "お問い合わせ",
      expTitle: "私たちの実績",
      web: "ウェブデザイン",
      prog: "プログラミング",
      cust: "カスタマーサービス",
      teach: "講師・指導",
      phoneHeader: "電話番号",
      addressHeader: "住所",
      hoursHeader: "営業時間",
      monFri: "月曜 - 金曜",
      sat: "土曜",
      sun: "日曜: 定休日",
      rights: "全著作権所有。",
      location: "〒163-1327 東京都新宿区西新宿6丁目5-1 新宿アイランドタワー 27F"
    }
  };

  const t = content[lang];

  if (location.pathname === '/') return null;

  return (
    <footer className="custom-footer">
      <div className="container">

        {/* Level 1: Links */}
        <div className="footer-tier links-tier">
          <ul className="footer-nav">
            <li><Link className={location.pathname === '/' ? 'active-link' : ''} to="/">{t.home}</Link></li>
            <li><Link className={location.pathname === '/getting-started' ? 'active-link' : ''} to="/getting-started">{t.start}</Link></li>
            <li><Link className={location.pathname === '/courses' ? 'active-link' : ''} to="/courses">{t.courses}</Link></li>
            <li><Link className={location.pathname === '/faq' ? 'active-link' : ''} to="/faq">{t.faq}</Link></li>
            <li><Link className={location.pathname === '/about' ? 'active-link' : ''} to="/about">{t.about}</Link></li>
            {/* <li><Link className={location.pathname === '/stay-updated' ? 'active-link' : ''} to="/stay-updated">{t.updates}</Link></li> */}
            <li><Link className={location.pathname === '/contact' ? 'active-link' : ''} to="/contact">{t.contact}</Link></li>
          </ul>
        </div>

        <hr className="footer-divider" />

        {/* Level 2: Experience */}
        <div className="footer-tier experience-tier">
          <h5 className="section-title">{t.expTitle}</h5>
          <div className="row g-4">
            <div className="col-6 col-md-3">
              <div className="exp-item">
                <span className="exp-label">{t.web} <small>(12y)</small></span>
                <div className="progress-bar-wrap"><div className="progress-fill" style={{ width: '100%' }}></div></div>
                <span className="exp-pct">100%</span>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="exp-item">
                <span className="exp-label">{t.prog} <small>(10y)</small></span>
                <div className="progress-bar-wrap"><div className="progress-fill" style={{ width: '80%' }}></div></div>
                <span className="exp-pct">80%</span>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="exp-item">
                <span className="exp-label">{t.cust} <small>(9y)</small></span>
                <div className="progress-bar-wrap"><div className="progress-fill" style={{ width: '70%' }}></div></div>
                <span className="exp-pct">70%</span>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="exp-item">
                <span className="exp-label">{t.teach} <small>(7y)</small></span>
                <div className="progress-bar-wrap"><div className="progress-fill" style={{ width: '50%' }}></div></div>
                <span className="exp-pct">50%</span>
              </div>
            </div>
          </div>
        </div>

        <hr className="footer-divider" />

        {/* Level 3: Contact Info */}
        <div className="footer-tier contact-tier">
          <div className="row text-center text-md-start">
            <div className="col-md-4 mb-4 mb-md-0">
              <div className="contact-box">
                <FiPhone className="contact-icon" />
                <h6>{t.phoneHeader}</h6>
                <p>03-6773-4452<br /></p>
              </div>
            </div>
            <div className="col-md-4 mb-4 mb-md-0">
              <div className="contact-box">
                <FiMapPin className="contact-icon" />
                <h6>{t.addressHeader}</h6>
                <p>{t.location}</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="contact-box">
                <FiClock className="contact-icon" />
                <h6>{t.hoursHeader}</h6>
                <p>{t.monFri}: 09:00-18:00 / {t.sat}: 09:00-17:00<br /><span>{t.sun}</span></p>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom text-center">
          <p>&copy; 2026 Level 9 Coaching. {t.rights}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;